var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSliderArrow = function SvgSliderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 22 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 40.95 0 20.55 20.4.05l1.6 1.6-18.8 18.9L22 39.35l-1.6 1.6Z"
  })));
};
export default SvgSliderArrow;